export default __webpack_public_path__ + "static/media/CloseCircle.3cb51a13.svg";